<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 18 18">
    <g fill="currentColor" opacity="1">
      <path
        d="M12.2041 0.0107422C13.2128 0.113005 14 0.964349 14 2V3H12V2H4V14H12V13H14V14C14 15.0357 13.2128 15.887 12.2041 15.9893L12 16H4C2.89543 16 2 15.1046 2 14V2C2 0.895431 2.89543 3.22128e-08 4 0H12L12.2041 0.0107422ZM11.6475 4.44531C11.854 4.2388 12.1877 4.23777 12.3926 4.44336L15.4912 7.55078C15.6005 7.66078 15.6474 7.80596 15.6396 7.9502C15.6468 8.09451 15.5996 8.24122 15.4893 8.35156L12.3721 11.4766C12.1657 11.6825 11.8331 11.6839 11.6279 11.4785C11.4231 11.273 11.4317 10.9187 11.4326 10.5781L11.4375 9.00391L8.0625 9.00977C7.50965 9.01075 7.06072 8.56262 7.06055 8.00977V7.89258C7.0605 7.33886 7.51071 6.89057 8.06445 6.89258L11.4434 6.9043L11.4482 5.33105C11.4485 5.12486 11.4414 4.65224 11.6475 4.44531Z"
        fill="#868D9C"
      />
    </g>
  </svg>
</template>
